import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cuentas: [],
  currentCuenta: null,
  abonos: [],
  currentAbono: null,
  filters: {},
};

export const abonosSlice = createSlice({
  name: "abonos",
  initialState,
  reducers: {
    setCuentas: (state, action) => ({
      ...state,
      cuentas: action.payload,
    }),
    addCuenta: (state, action) => ({
      ...state,
      cuentas: [...state.cuentas, action.payload],
    }),
    updateCuenta: (state, action) => ({
      ...state,
      cuentas: state.cuentas.map((cuenta) => {
        if (cuenta._id === action.payload.id || cuenta.id === action.payload.id) {
          return { ...cuenta, ...action.payload.data };
        }
        return cuenta;
      }),
    }),
    removeCuenta: (state, action) => ({
      ...state,
      cuentas: state.cuentas.filter((cuenta) => {
        return cuenta._id !== action.payload && cuenta.id !== action.payload;
      }),
    }),
    setCurrentCuenta: (state, action) => ({
      ...state,
      currentCuenta: action.payload,
    }),
    setAbonos: (state, action) => ({
      ...state,
      abonos: action.payload,
    }),
    setCurrentAbono: (state, action) => ({
      ...state,
      currentAbono: action.payload,
    }),
    setAbonosFilters: (state, action) => ({
      ...state,
      filters: action.payload,
    }),
  },
});

export const {
  setCuentas,
  addCuenta,
  updateCuenta,
  removeCuenta,
  setCurrentCuenta,
  setAbonos,
  setCurrentAbono,
  setAbonosFilters,
} = abonosSlice.actions;

export default abonosSlice.reducer;
